import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'planback.mobile.language';

export default function MobileLanguageSwitch() {
  const { i18n } = useTranslation(['common']);
  const current = i18n.language === 'de' ? 'de' : 'en';

  function toggle() {
    const next = current === 'de' ? 'en' : 'de';
    i18n.changeLanguage(next);
    localStorage.setItem(STORAGE_KEY, next);
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className="min-h-12 min-w-12 text-sm font-semibold uppercase tracking-wide text-gray-600 px-3 rounded-lg border border-gray-300 active:bg-gray-100"
      aria-label="language"
    >
      {current === 'de' ? 'DE' : 'EN'}
    </button>
  );
}
